import { combineReducers } from 'redux';
import { reducer as heroBannerReducer } from './reducers/heroBanner';
import { reducer as megaphoneBannerReducer } from './reducers/megaphoneBanner';
import { reducer as webCardsReducer } from './reducers/webCards';

export default combineReducers({
  heroBanner: heroBannerReducer,
  megaphoneBanner: megaphoneBannerReducer,
  webCards: webCardsReducer,
});
